import React from 'react';
import '../styles/dashboard-pages.css';

const SystemOverview: React.FC = () => {
  return (
    <div className="dashboard-page">
      <div className="page-header">
        <h1>System Overview</h1>
        <p>Monitor your neural network training infrastructure</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">🏃</div>
          <div className="stat-content">
            <div className="stat-label">Active Training Sessions</div>
            <div className="stat-value">0</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">✅</div>
          <div className="stat-content">
            <div className="stat-label">Completed Models</div>
            <div className="stat-value">0</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">⚠️</div>
          <div className="stat-content">
            <div className="stat-label">Failed Trainings</div>
            <div className="stat-value">0</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">💾</div>
          <div className="stat-content">
            <div className="stat-label">Disk Usage</div>
            <div className="stat-value">0 MB</div>
          </div>
        </div>
      </div>

      <div className="page-sections">
        <section className="section-card">
          <h2>Recent Training Sessions</h2>
          <div className="empty-state">
            <div className="empty-icon">📋</div>
            <p>No training sessions yet. Start training in the Training section.</p>
          </div>
        </section>

        <section className="section-card">
          <h2>System Health</h2>
          <div className="health-indicators">
            <div className="health-item">
              <div className="health-label">Backend API</div>
              <div className="health-status connected">Connected</div>
            </div>
            <div className="health-item">
              <div className="health-label">Database</div>
              <div className="health-status connected">Connected</div>
            </div>
            <div className="health-item">
              <div className="health-label">GPU Status</div>
              <div className="health-status unknown">Unknown</div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SystemOverview;
